import React from 'react'

const Divider = () => {
    return (
        <div>
            <div className="Divider">
                <hr className="Divider-rule" />
            </div>
        </div>
    )
}

export default Divider
